import React from 'react';
import classNames from 'classnames';
import omit from '../util/omit';
import Element from './Element';
import ConfigContext from './configContext';

const SkeletonInput = props => {
  const renderSkeletonInput = ({ getPrefixCls }) => {
    const { prefixCls: customizePrefixCls, className, active } = props;
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const otherProps = omit(props, ['prefixCls']);
    const cls = classNames(
      prefixCls,
      `${prefixCls}-element`,
      { [`${prefixCls}-active`]: active },
      className,
    );
    return (
      <div className={cls}>
        <Element prefixCls={`${prefixCls}-input`} {...otherProps} />
      </div>
    );
  };
  return <ConfigContext.Consumer>{renderSkeletonInput}</ConfigContext.Consumer>;
};
SkeletonInput.defaultProps = {
  size: 'default',
};
export default SkeletonInput;



// WEBPACK FOOTER //
// ./src/skeleton/Input.jsx